import { ApiHosts, handleResponseOld, makeGet } from './helpers';

/**
 * @category Search API
 * @see fetchSimilarItems
 */
type FetchSimilarItemsParams = {
    authToken: string;
    deployment: string;
    ipAddress: string;
    isBot: boolean;
    page?: number;
    searchExclusions: number[];
    similarItemInfo: any;
};
/**
 * fetches similar items via Get to Search API
 * @function fetchSimilarItems
 * @category Search API
 * @param {FetchSimilarItemsParams}
 * @see https://search-party-DEPLOYMENT.liveauctioneers.com/search/similaritems-
 * @see https://console.aws.amazon.com/apigateway/home?region=us-east-1#/apis/p8swwvetjb/resources/qa8ucb/methods/GET
 * @see https://github.com/LIVEauctioneers/search-party/blob/master/functions/SimilarItems/main.go
 */
const fetchSimilarItems = ({
    authToken,
    deployment,
    ipAddress,
    page,
    searchExclusions = [],
    similarItemInfo,
}: FetchSimilarItemsParams) =>
    new Promise<any>((resolve, reject) => {
        const params = {
            options: {
                auctionHouse: [{ exclude: searchExclusions, include: [] }],
                status: ['upcoming', 'live', 'online'],
            },
            page: page,
            pageSize: 12,
            searchTerm: similarItemInfo.title,
        };

        const request = makeGet({
            apiPath: 'v4/similaritems',
            authToken,
            deployment,
            ipAddress,
            path: ApiHosts.Search,
        });

        request.query({
            houseId: similarItemInfo.sellerId,
            ids: JSON.stringify(similarItemInfo.categoryIds),
            itemId: similarItemInfo.itemId,
            parameters: JSON.stringify(params),
        });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });

export default {
    fetchSimilarItems,
};
